export const getIconName = (name, ext) => {
  return `${name}${name.slice(-4) == ".png" || name.slice(-4) == ".svg" ? "" : ext}`;
};
